
  import "./sentry";
  import { createRoot } from "react-dom/client";
  import App from "./app/App.tsx";
  import "./styles/index.css";

  // כשיש deploy חדש, קבצי JS מקבלים שמות חדשים.
  // משתמשים עם HTML ישן מקבלים "Failed to fetch dynamically imported module".
  // Vite מפלט את ה-event הזה בדיוק למקרה זה — פשוט טוענים מחדש.
  window.addEventListener("vite:preloadError", () => {
    window.location.reload();
  });

  createRoot(document.getElementById("root")!).render(<App />);
